module.exports = __webpack_public_path__ + "static/media/isomurexterieur.d15683ee.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/isomurexterieur.PNG
// module id = 1097
// module chunks = 0